import React, { useEffect, useRef, useState } from 'react';
import browserInfo from 'browser-info';

import AltFieldMapper, { AltFieldItem, validateRequiredFields } from 'views/AltFieldMapper.js';
import Appearance from 'styles/Appearance.js';
import Button from 'views/Button.js';
import ProductManuals from 'views/site/ProductManuals.js';
import { CardElement, Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import LottieView from 'views/Lottie.js';
import { NavigationSectionHeader } from 'managers/Components.js';
import QueryString from 'query-string';
import Request from 'files/Request.js';
import Utils from 'files/Utils.js';

export const BackgroundCheckInformationRequest = ({ dealership, utils }) => {

    const [edits, setEdits] = useState({});
    const [loading, setLoading] = useState(false);
    const [request, setRequest] = useState({});

    const countries = {
        "AFG": "Afghanistan",
        "ALB": "Albania",
        "DZA": "Algeria",
        "ASM": "American Samoa",
        "AND": "Andorra",
        "AGO": "Angola",
        "AIA": "Anguilla",
        "ATA": "Antarctica",
        "ATG": "Antigua and Barbuda",
        "ARG": "Argentina",
        "ARM": "Armenia",
        "ABW": "Aruba",
        "AUS": "Australia",
        "AUT": "Austria",
        "AZE": "Azerbaijan",
        "BHS": "Bahamas",
        "BHR": "Bahrain",
        "BGD": "Bangladesh",
        "BRB": "Barbados",
        "BLR": "Belarus",
        "BEL": "Belgium",
        "BLZ": "Belize",
        "BEN": "Benin",
        "BMU": "Bermuda",
        "BTN": "Bhutan",
        "BOL": "Bolivia (Plurinational State of)",
        "BES": "Bonaire, Sint Eustatius and Saba",
        "BIH": "Bosnia and Herzegovina",
        "BWA": "Botswana",
        "BVT": "Bouvet Island",
        "BRA": "Brazil",
        "IOT": "British Indian Ocean Territory",
        "BRN": "Brunei Darussalam",
        "BGR": "Bulgaria",
        "BFA": "Burkina Faso",
        "BDI": "Burundi",
        "CPV": "Cabo Verde",
        "KHM": "Cambodia",
        "CMR": "Cameroon",
        "CAN": "Canada",
        "CYM": "Cayman Islands",
        "CAF": "Central African Republic",
        "TCD": "Chad",
        "CHL": "Chile",
        "CHN": "China",
        "CXR": "Christmas Island",
        "CCK": "Cocos (Keeling) Islands",
        "COL": "Colombia",
        "COM": "Comoros",
        "COD": "Congo (the Democratic Republic of the)",
        "COG": "Congo",
        "COK": "Cook Islands",
        "CRI": "Costa Rica",
        "HRV": "Croatia",
        "CUB": "Cuba",
        "CUW": "Curaçao",
        "CYP": "Cyprus",
        "CZE": "Czechia",
        "CIV": "Côte d'Ivoire",
        "DNK": "Denmark",
        "DJI": "Djibouti",
        "DMA": "Dominica",
        "DOM": "Dominican Republic",
        "ECU": "Ecuador",
        "EGY": "Egypt",
        "SLV": "El Salvador",
        "GNQ": "Equatorial Guinea",
        "ERI": "Eritrea",
        "EST": "Estonia",
        "SWZ": "Eswatini",
        "ETH": "Ethiopia",
        "FLK": "Falkland Islands [Malvinas]",
        "FRO": "Faroe Islands",
        "FJI": "Fiji",
        "FIN": "Finland",
        "FRA": "France",
        "GUF": "French Guiana",
        "PYF": "French Polynesia",
        "ATF": "French Southern Territories",
        "GAB": "Gabon",
        "GMB": "Gambia",
        "GEO": "Georgia",
        "DEU": "Germany",
        "GHA": "Ghana",
        "GIB": "Gibraltar",
        "GRC": "Greece",
        "GRL": "Greenland",
        "GRD": "Grenada",
        "GLP": "Guadeloupe",
        "GUM": "Guam",
        "GTM": "Guatemala",
        "GGY": "Guernsey",
        "GIN": "Guinea",
        "GNB": "Guinea-Bissau",
        "GUY": "Guyana",
        "HTI": "Haiti",
        "HMD": "Heard Island and McDonald Islands",
        "VAT": "Holy See",
        "HND": "Honduras",
        "HKG": "Hong Kong",
        "HUN": "Hungary",
        "ISL": "Iceland",
        "IND": "India",
        "IDN": "Indonesia",
        "IRN": "Iran (Islamic Republic of)",
        "IRQ": "Iraq",
        "IRL": "Ireland",
        "IMN": "Isle of Man",
        "ISR": "Israel",
        "ITA": "Italy",
        "JAM": "Jamaica",
        "JPN": "Japan",
        "JEY": "Jersey",
        "JOR": "Jordan",
        "KAZ": "Kazakhstan",
        "KEN": "Kenya",
        "KIR": "Kiribati",
        "PRK": "Korea (the Democratic People's Republic of)",
        "KOR": "Korea (the Republic of)",
        "KWT": "Kuwait",
        "KGZ": "Kyrgyzstan",
        "LAO": "Lao People's Democratic Republic",
        "LVA": "Latvia",
        "LBN": "Lebanon",
        "LSO": "Lesotho",
        "LBR": "Liberia",
        "LBY": "Libya",
        "LIE": "Liechtenstein",
        "LTU": "Lithuania",
        "LUX": "Luxembourg",
        "MAC": "Macao",
        "MDG": "Madagascar",
        "MWI": "Malawi",
        "MYS": "Malaysia",
        "MDV": "Maldives",
        "MLI": "Mali",
        "MLT": "Malta",
        "MHL": "Marshall Islands",
        "MTQ": "Martinique",
        "MRT": "Mauritania",
        "MUS": "Mauritius",
        "MYT": "Mayotte",
        "MEX": "Mexico",
        "FSM": "Micronesia (Federated States of)",
        "MDA": "Moldova (the Republic of)",
        "MCO": "Monaco",
        "MNG": "Mongolia",
        "MNE": "Montenegro",
        "MSR": "Montserrat",
        "MAR": "Morocco",
        "MOZ": "Mozambique",
        "MMR": "Myanmar",
        "NAM": "Namibia",
        "NRU": "Nauru",
        "NPL": "Nepal",
        "NLD": "Netherlands",
        "NCL": "New Caledonia",
        "NZL": "New Zealand",
        "NIC": "Nicaragua",
        "NER": "Niger",
        "NGA": "Nigeria",
        "NIU": "Niue",
        "NFK": "Norfolk Island",
        "MNP": "Northern Mariana Islands",
        "NOR": "Norway",
        "OMN": "Oman",
        "PAK": "Pakistan",
        "PLW": "Palau",
        "PSE": "Palestine, State of",
        "PAN": "Panama",
        "PNG": "Papua New Guinea",
        "PRY": "Paraguay",
        "PER": "Peru",
        "PHL": "Philippines",
        "PCN": "Pitcairn",
        "POL": "Poland",
        "PRT": "Portugal",
        "PRI": "Puerto Rico",
        "QAT": "Qatar",
        "MKD": "Republic of North Macedonia",
        "ROU": "Romania",
        "RUS": "Russian Federation",
        "RWA": "Rwanda",
        "REU": "Réunion",
        "BLM": "Saint Barthélemy",
        "SHN": "Saint Helena, Ascension and Tristan da Cunha",
        "KNA": "Saint Kitts and Nevis",
        "LCA": "Saint Lucia",
        "MAF": "Saint Martin (French part)",
        "SPM": "Saint Pierre and Miquelon",
        "VCT": "Saint Vincent and the Grenadines",
        "WSM": "Samoa",
        "SMR": "San Marino",
        "STP": "Sao Tome and Principe",
        "SAU": "Saudi Arabia",
        "SEN": "Senegal",
        "SRB": "Serbia",
        "SYC": "Seychelles",
        "SLE": "Sierra Leone",
        "SGP": "Singapore",
        "SXM": "Sint Maarten (Dutch part)",
        "SVK": "Slovakia",
        "SVN": "Slovenia",
        "SLB": "Solomon Islands",
        "SOM": "Somalia",
        "ZAF": "South Africa",
        "SGS": "South Georgia and the South Sandwich Islands",
        "SSD": "South Sudan",
        "ESP": "Spain",
        "LKA": "Sri Lanka",
        "SDN": "Sudan",
        "SUR": "Suriname",
        "SJM": "Svalbard and Jan Mayen",
        "SWE": "Sweden",
        "CHE": "Switzerland",
        "SYR": "Syrian Arab Republic",
        "TWN": "Taiwan",
        "TJK": "Tajikistan",
        "TZA": "Tanzania, United Republic of",
        "THA": "Thailand",
        "TLS": "Timor-Leste",
        "TGO": "Togo",
        "TKL": "Tokelau",
        "TON": "Tonga",
        "TTO": "Trinidad and Tobago",
        "TUN": "Tunisia",
        "TUR": "Turkey",
        "TKM": "Turkmenistan",
        "TCA": "Turks and Caicos Islands",
        "TUV": "Tuvalu",
        "UGA": "Uganda",
        "UKR": "Ukraine",
        "ARE": "United Arab Emirates",
        "GBR": "United Kingdom of Great Britain and Northern Ireland",
        "UMI": "United States Minor Outlying Islands",
        "USA": "United States",
        "URY": "Uruguay",
        "UZB": "Uzbekistan",
        "VUT": "Vanuatu",
        "VEN": "Venezuela (Bolivarian Republic of)",
        "VNM": "Viet Nam",
        "VGB": "Virgin Islands (British)",
        "VIR": "Virgin Islands (U.S.)",
        "WLF": "Wallis and Futuna",
        "ESH": "Western Sahara",
        "YEM": "Yemen",
        "ZMB": "Zambia",
        "ZWE": "Zimbabwe",
        "ALA": "Åland Islands"
    }

    const onSubmitClick = async () => {
        try {

            // verify that required fields were provided
            await validateRequiredFields(getFields);

            // set loading flag and send request to server
            setLoading('submit');
            await Request.post(utils, '/users/', {
                data: edits,
                token: request.token,
                type: 'process_background_check_information_request'
            });
            
            // end loading and show confirmation alert
            setLoading(false);
            utils.alert.show({
                title: 'All Done!',
                message: `Your information has been submitted and our dealership will begin processing your background check shortly. We'll reach out if we have any questions or concerns about the information you provided.`
            });

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue submitting your information. ${e.message || 'An unknown error occurred'}`
            });
        }
    }
    
    const onUpdateTarget = props => {
        setEdits(edits => ({ ...edits, ...props }));
    }

    const getCountryItems = () => {
        return Object.keys(countries).map(key => ({
            id: key,
            title: countries[key]
        }));
    }

    const getDisclaimer = () => {
        return (
            <span style={{
                color: Appearance.colors.subText(),
                display: 'block',
                fontSize: 11,
                fontWeight: 500,
                lineHeight: 1.5,
                marginTop: 12,
                padding: 12,
                width: '100%'
            }}>{'By submitting your request for this report, you understand that the report does not constitute a “consumer report” as that term is defined in the federal Fair Credit Reporting Act, 15 USC 1681 et seq. (FCRA). Accordingly, these results may not be used in whole or in part as a factor in determining eligibility for credit, insurance, employment or another permissible purpose under the FCRA.'}</span>
        )
    }
    
    const getFields = () => {
        return [{
            key: 'details',
            title: 'Personal Details'.toUpperCase(),
            items: [{
                component: 'textfield',
                key: 'first_name',
                onChange: text => onUpdateTarget({ first_name: text }),
                props: {
                    autoComplete: 'given-name'
                },
                title: 'First Name',
                value: edits.first_name
            },{
                component: 'textfield',
                key: 'last_name',
                onChange: text => onUpdateTarget({ last_name: text }),
                props: {
                    autoComplete: 'family-name'
                },
                title: 'Last Name',
                value: edits.last_name
            },{
                component: 'date_picker_dropdown',
                key: 'dob',
                onChange: date => onUpdateTarget({ dob: date }),
                props: {
                    autoComplete: 'off'
                },
                title: 'Date of Birth',
                value: edits.dob
            },{
                component: 'textfield',
                key: 'ssn_last_4',
                onChange: val => onUpdateTarget({ ssn_last_4: val }),
                props: {
                    autoComplete: 'off',
                    format: 'number'
                },
                title: 'Social Security Number (Last 4)',
                value: edits.ssn_last_4
            }]
        },{
            key: 'contact_information',
            title: 'Contact Information'.toUpperCase(),
            items: [{
                component: 'textfield',
                key: 'email_address',
                onChange: text => onUpdateTarget({ email_address: text }),
                props: {
                    autoComplete: 'email'
                },
                title: 'Email Address',
                value: edits.email_address
            },{
                component: 'textfield',
                key: 'phone_number',
                onChange: text => onUpdateTarget({ phone_number: text }),
                props: {
                    autoComplete: 'tel',
                    format: 'phone_number'
                },
                title: 'Phone Number',
                value: edits.phone_number
            }]
        },{
            key: 'address',
            title: 'Physical Address'.toUpperCase(),
            items: [{
                component: 'textfield',
                key: 'house_number',
                onChange: text => onUpdateTarget({ house_number: text }),
                props: {
                    autoComplete: 'house-number',  // invalid value
                    format: 'number'
                },
                title: 'House Number',
                value: edits.house_number
            },{
                component: 'textfield',
                key: 'street_name',
                onChange: text => onUpdateTarget({ street_name: text }),
                props: {
                    autoComplete: 'street-name' // invalid value
                },
                title: 'Street Name',
                value: edits.street_name
            },{
                component: 'textfield',
                key: 'city',
                onChange: text => onUpdateTarget({ city: text }),
                props: {
                    autoComplete: 'address-level2'
                },
                title: 'City',
                value: edits.city
            },{
                component: 'textfield',
                key: 'state',
                onChange: text => onUpdateTarget({ state: text }),
                props: {
                    autoComplete: 'address-level1'
                },
                title: 'State',
                value: edits.state
            },{
                component: 'textfield',
                key: 'zipcode',
                onChange: text => onUpdateTarget({ zipcode: text }),
                props: {
                    autoComplete: 'postal-code'
                },
                title: 'Zipcode',
                value: edits.zipcode
            },{
                component: 'list',
                items: getCountryItems(),
                key: 'country',
                onChange: item => onUpdateTarget({ country: item && item.title }),
                title: 'Country',
                value: edits.country
            }]
        }];
    }

    useEffect(() => {
        let request = QueryString.parse(window.location.search);
        setRequest(request);
    }, []);


    return (
        <>
        <NavigationSectionHeader
        dealership={dealership} 
        eyebrow={'Careers'}
            identifier={'background_check_information_request'}
            subtitle={'The information we need to run a background check for your application.'}
        title={'Background Check Information Request'} 
        utils={utils} />
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '5vw',
            width: '100%'
        }}>
            <div style={{
                ...Appearance.styles.unstyledPanel(),
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                marginBottom: Utils.isMobile() ? 24 : 0,
                maxWidth: 1000,
                padding: Utils.isMobile() ? 24 : '3vw',
                textAlign: 'center',
                width: '100%'
            }}>
                <AltFieldMapper
                fields={getFields()}
                utils={utils} />
                {getDisclaimer()}
                <Button 
                color={'primary'}
                containerStyle={{
                    marginTop: 24
                }}
                label={'Submit'}
                loading={loading === 'submit'}
                onClick={onSubmitClick} 
                style={{
                    height: '100%',
                    minWidth: 250,
                    padding: '12px 24px 12px 24px',
                    width: '100%'
                }}
                type={'large'} />
            </div>
        </div>
        </>
    )
}

export const CertificationTestOnboarding = ({ dealership, utils }) => {

    const stripeProps = useRef(null);

    const [loading, setLoading] = useState(true);
    const [paymentMethodCompleted, setPaymentMethodCompleted] = useState(false);
    const [user, setUser] = useState(null);

    const onClearClick = () => {
        utils.alert.show({
            title: 'Clear Progress',
            message: 'Are you sure you want to clear all fields and start over?',
            buttons: [{
                key: 'confirm',
                title: 'Yes',
                style: 'default'
            },{
                key: 'cancel',
                title: 'Cancel',
                style: 'cancel'
            }],
            onClick: key => {
                if(key === 'confirm') {
                    let element = stripeProps.current.elements.getElement(CardElement);
                    element.clear();
                }
            }
        });
    }

    const onSubmitClick = async () => {
        try {

            // prevent moving forward if method input is not complete
            if(paymentMethodCompleted === false) {
                throw new Error('Please fill out your card number, expiration date, and cvc code to continue.');
            }

            // generate card token for request
            setLoading('submit');
            let element = stripeProps.current.elements.getElement(CardElement);
            let { token } = await stripeProps.current.stripe.createToken(element);

            // send additional request to server to process test payment
            await Request.post(utils, '/payments/', {
                ...user,
                card_token: token?.id,
                dealership_id: dealership.id,
                type: 'new_certification_test_payment'
            });

            // end loading and clear payment method field
            setLoading(false);
            element.clear();

            // show confirmation alert and update page to show links for trainees
            utils.alert.show({
                title: 'All Done!',
                message: `Your ${utils.dealership.get().name} payment has been processed. Check your inbox for your email confirmation.`
            });

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue processing your payment. ${e.message || 'An unknown error occurred'}`
            });
        }
    }

    const getContent = () => {
        return (
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '5vw',
                width: '100%'
            }}>
                <div style={{
                    ...Appearance.styles.unstyledPanel(),
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: Utils.isMobile() ? 24 : 0,
                    maxWidth: 1250,
                    padding: Utils.isMobile() ? 24 : '3vw',
                    textAlign: 'center',
                    width: '100%'
                }}>
                    <img 
                    src={'images/vector-sensor-group.png'}
                    style={{
                        height: 'auto',
                        marginBottom: Utils.isMobile() === true ? 24 : 36,
                        maxWidth: 500,
                        objectFit: 'contain',
                        width: '100%'
                    }} />
                    <span style={{
                        color: Appearance.colors.text(),
                        fontFamily: Appearance.fonts.getFamilyForWeight(400),
                        fontSize: 18,
                        maxWidth: 750
                    }}>{`${utils.dealership.get().name} provides safety advisor certification testing for all newly hired safety advisors. A per-test fee of $10 is required to prepare the cetification test for your account. Please provide your credit or debit card details below to continue.`}</span>
                </div>
                {user !== null && (
                    <div style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        maxWidth: 1250,
                        padding: Utils.isMobile() ? 0 : '3vw',
                        textAlign: 'center',
                        width: '100%'
                    }}>
                        <div style={{
                            display: 'block',
                            maxWidth: 750,
                            width: '100%'
                        }}>
                            {getStripeCardComponent()}
                            <div style={{
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row',
                                marginTop: 24,
                                width: '100%'
                            }}>
                                <div style={{
                                    paddingRight: 4,
                                    width: '50%'
                                }}>
                                    <Button 
                                    color={'dark'}
                                    label={'Clear'}
                                    onClick={onClearClick} 
                                    type={'large'} />
                                </div>
                               
                                <div style={{
                                    paddingLeft: 4,
                                    width: '50%'
                                }}>
                                    <Button 
                                    color={'primary'}
                                    label={'Submit'}
                                    loading={loading === 'submit'}
                                    onClick={onSubmitClick} 
                                    type={'large'} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const getStripeCardComponent = () => {
        return user !== null && (
            <div style={{
                ...Appearance.styles.unstyledPanel(),
            }}>
                <div style={{
                    padding: Utils.isMobile() ? 24 : 36,
                    width: '100%'
                }}>
                    <AltFieldItem 
                    content={(
                        <Elements stripe={utils.stripe}>
                            <ElementsConsumer>
                                {props => {
                                    stripeProps.current = props;
                                    return (
                                        <div style={{
                                            backgroundColor: Appearance.colors.textField(),
                                            border: `1px solid ${Appearance.colors.divider()}`,
                                            borderRadius: 8,
                                            padding: '0.5275rem 0.75rem',
                                            width: '100%'
                                        }}>
                                            <CardElement
                                            onChange={({ complete }) => setPaymentMethodCompleted(complete)}
                                            options={{
                                                hidePostalCode: true,
                                                style: {
                                                    invalid: {
                                                        color: Appearance.colors.red,
                                                    },
                                                    base: {
                                                        backgroundColor: Appearance.colors.textField(),
                                                        color: Appearance.colors.text(),
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        '::placeholder': {
                                                            color: Appearance.colors.subText(),
                                                        },
                                                    }
                                                }
                                            }} />
                                        </div>
                                    )
                                }}
                            </ElementsConsumer>
                        </Elements>
                    )} 
                    item={{
                        required: true,
                        title: 'Credit or Debit Card',
                        value: paymentMethodCompleted || null
                    }}
                    lastItem={true}
                    utils={utils} />
                </div>
            </div>
        )
    }

    const setupUserContent = async () => {
        try {

            // get token from request query string
            let { token } = QueryString.parse(window.location.search);
            if(!token) {
                throw new Error('an access token is required when starting the onboarding process.');
            }

            // set loading flag and submit request to server
            setLoading(true);
            let { user } = await Request.post(utils, '/users/', {
                origin: 'replicated_website',
                refresh_token: token,
                type: 'login'
            });

            // end loading and update local state with user account details
            setLoading(false);
            setUser({ 
                token: user.token,
                user_id: user.user_id
            });

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue setting up the onboarding process. ${e.message || 'An unknown error occurred'}`
            });
        }
    }

    useEffect(() => {
        setupUserContent();
    }, []);

    return (
        <>
        <NavigationSectionHeader
        dealership={dealership} 
        eyebrow={'Certification'}
            identifier={'certification_test_onboarding'}
            subtitle={'Register for the Safety Advisor certification test.'}
        title={'Certification Test Onboarding'} 
        utils={utils} />
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }}>
            {getContent()}
        </div>
        </>
    )
}

export const TraineeSignup = ({ dealership, utils }) => {

    const account = useRef({});
    const stripeProps = useRef(null);

    const [edits, setEdits] = useState({});
    const [enabled, setEnabled] = useState(null);
    const [loading, setLoading] = useState(false);
    const [paymentMethodCompleted, setPaymentMethodCompleted] = useState(false);

    const onClearClick = () => {
        utils.alert.show({
            title: 'Clear Progress',
            message: 'Are you sure you want to clear all fields and start over?',
            buttons: [{
                key: 'confirm',
                title: 'Yes',
                style: 'default'
            },{
                key: 'cancel',
                title: 'Cancel',
                style: 'cancel'
            }],
            onClick: key => {
                if(key === 'confirm') {
                    setEdits({});
                    return;
                }
            }
        });
    }

    const onSubmitClick = async () => {
        try {

            // verify that all required fields were completed
            await validateRequiredFields(getFields);

            // verify that both password fields match 
            if(edits.password !== edits.password_confirm) {
                throw new Error('The passwords that you provided do not match');
            }

            // prevent moving forward if method input is not complete
            let shouldRequestPayment = dealership.trainee_signup.setup_testcom_account === true;
            if(shouldRequestPayment === true && paymentMethodCompleted === false) {
                throw new Error('Please fill out your card number, expiration date, and cvc code to continue.');
            }

            // generate card token and add parameters to request payload if applicable
            setLoading(true);
            let element = shouldRequestPayment ? stripeProps.current.elements.getElement(CardElement) : null;
            let { token } = shouldRequestPayment ? await stripeProps.current.stripe.createToken(element) : {};

            // set loading flag and send request to server to create user account if applicable
            if(!account.current?.user_id) { 
                account.current = await Request.post(utils, '/users/', {
                    ...edits,
                    dealership_id: dealership.id,
                    type: 'trainee_signup'
                });
            }

            // send additional request to server to process test payment if applciable
            if(shouldRequestPayment === true) {
                await Request.post(utils, '/payments/', {
                    card_token: token?.id,
                    dealership_id: dealership.id,
                    token: account.current.token,
                    type: 'new_certification_test_payment',
                    user_id: account.current.user_id
                });
            }

            // end loading and clear fields for new edits
            setLoading(false);
            setEdits({});

            // clear payment method field if applicable
            if(element) {
                element.clear();
            }

            // show confirmation alert and update page to show links for trainees
            utils.alert.show({
                title: 'All Done!',
                message: `Your ${utils.dealership.get().name} account has been created and is ready to use. Check your inbox for your email confirmation.`
            });

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue creating your account. ${e.message || 'An unknown error occurred'}`
            });
        }
    }

    const onUpdateTarget = props => {
        setEdits(edits => ({ ...edits, ...props }));
    }

    const getContent = () => {

        // show error message if dealership has disabled trainee signup links
        if(enabled === false) {
            return (
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: '5vw',
                    width: '100%'
                }}>
                    <div style={{
                        ...Appearance.styles.unstyledPanel(),
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        marginBottom: 24,
                        maxWidth: 1250,
                        padding: Utils.isMobile() ? 24 : '3vw',
                        textAlign: 'center',
                        width: '100%'
                    }}>
                        <img 
                        src={'images/vector-sensor-group.png'}
                        style={{
                            height: 'auto',
                            marginBottom: Utils.isMobile() === true ? 24 : 36,
                            maxWidth: 500,
                            objectFit: 'contain',
                            width: '100%'
                        }} />
                        <span style={{
                            color: Appearance.colors.text(),
                            fontFamily: Appearance.fonts.getFamilyForWeight(400),
                            fontSize: 18,
                            maxWidth: 575
                        }}>{`${utils.dealership.get().name} is not accepting new trainee signups at this time. Please contact support if you believe this was done in error.`}</span>
                    </div>
                </div>
            )
        }

        // show signup form if dealership has enabled trainee signup links
        if(enabled === true) {
            return (
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: '5vw',
                    width: '100%'
                }}>
                    <div style={{
                        ...Appearance.styles.unstyledPanel(),
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        marginBottom: Utils.isMobile() ? 24 : 0,
                        maxWidth: 1250,
                        padding: Utils.isMobile() ? 24 : '3vw',
                        textAlign: 'center',
                        width: '100%'
                    }}>
                        <img 
                        src={'images/vector-sensor-group.png'}
                        style={{
                            height: 'auto',
                            marginBottom: Utils.isMobile() === true ? 24 : 36,
                            maxWidth: 500,
                            objectFit: 'contain',
                            width: '100%'
                        }} />
                        <span style={{
                            color: Appearance.colors.text(),
                            fontFamily: Appearance.fonts.getFamilyForWeight(400),
                            fontSize: 18,
                            maxWidth: 750
                        }}>{`Please use the form below to create your account for ${utils.dealership.get().name}. A ${utils.dealership.get().name} account gives you premium access to a library of training content geared towards preparing you for your future in direct sales.`}</span>
                    </div>
                    <div style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        maxWidth: 1250,
                        padding: Utils.isMobile() ? 0 : '3vw',
                        textAlign: 'center',
                        width: '100%'
                    }}>
                        <div style={{
                            display: 'block',
                            maxWidth: 750,
                            width: '100%'
                        }}>
                            <AltFieldMapper
                            fields={getFields()}
                            utils={utils} />
                            {dealership.trainee_signup.setup_testcom_account && getStripeCardComponent()}
                            <div style={{
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row',
                                marginTop: 24,
                                width: '100%'
                            }}>
                                <div style={{
                                    paddingRight: 4,
                                    width: '50%'
                                }}>
                                    <Button 
                                    color={'dark'}
                                    label={'Clear'}
                                    onClick={onClearClick} 
                                    type={'large'} />
                                </div>
                               
                                <div style={{
                                    paddingLeft: 4,
                                    width: '50%'
                                }}>
                                    <Button 
                                    color={'primary'}
                                    label={'Submit'}
                                    loading={loading}
                                    onClick={onSubmitClick} 
                                    type={'large'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    const getFields = () => {
        return [{
            key: 'account',
            style: { padding: Utils.isMobile() ? 24 : 36 },
            items: [{
                component: 'textfield',
                key: 'username',
                onChange: text => onUpdateTarget({ username: text }),
                title: 'Username',
                value: edits.username
            },{
                component: 'textfield',
                key: 'password',
                onChange: text => onUpdateTarget({ password: text }),
                props: {
                    autoComplete: 'new-password',
                    isSecure: true
                },
                title: 'Password',
                value: edits.password
            },{
                component: 'textfield',
                key: 'password_confirm',
                onChange: text => onUpdateTarget({ password_confirm: text }),
                props: {
                    autoComplete: 'new-password',
                    isSecure: true
                },
                title: 'Confirm Password',
                value: edits.password_confirm
            }]
        },{
            key: 'details',
            lastItem: false,
            style: { padding: Utils.isMobile() ? 24 : 36 },
            items: [{
                component: 'textfield',
                key: 'first_name',
                onChange: text => onUpdateTarget({ first_name: text }),
                props: {
                    autoComplete: 'given-name'
                },
                title: 'First Name',
                value: edits.first_name
            },{
                component: 'textfield',
                key: 'last_name',
                onChange: text => onUpdateTarget({ last_name: text }),
                props: {
                    autoComplete: 'family-name'
                },
                title: 'Last Name',
                value: edits.last_name
            },{
                component: 'textfield',
                key: 'email_address',
                onChange: text => onUpdateTarget({ email_address: text }),
                props: {
                    autoComplete: 'email'
                },
                title: 'Email Address',
                value: edits.email_address
            },{
                component: 'textfield',
                key: 'phone_number',
                onChange: text => onUpdateTarget({ phone_number: text }),
                props: {
                    autoComplete: 'tel',
                    format: 'phone_number'
                },
                title: 'Phone Number',
                value: edits.phone_number
            }]
        }];
    }

    const getStripeCardComponent = () => {
        return (
            <div style={{
                ...Appearance.styles.unstyledPanel(),
            }}>
                <span style={{
                    borderBottom: `1px solid ${Appearance.colors.divider()}`,
                    color: Appearance.colors.text(),
                    display: 'block',
                    fontFamily: Appearance.fonts.getFamilyForWeight(400),
                    fontSize: 16,
                    padding: Utils.isMobile() ? 24 : 36,
                    width: '100%'
                }}>{`${utils.dealership.get().name} provides safety advisor certification testing for all newly hired safety advisors. A per-test fee of $10 is required to prepare the cetification test for your account. Please provide your credit or debit card details below to continue.`}</span>

                <div style={{
                    padding: Utils.isMobile() ? 24 : 36,
                    width: '100%'
                }}>
                    <AltFieldItem 
                    content={(
                        <Elements stripe={utils.stripe}>
                            <ElementsConsumer>
                                {props => {
                                    stripeProps.current = props;
                                    return (
                                        <div style={{
                                            backgroundColor: Appearance.colors.textField(),
                                            border: `1px solid ${Appearance.colors.divider()}`,
                                            borderRadius: 8,
                                            padding: '0.5275rem 0.75rem',
                                            width: '100%'
                                        }}>
                                            <CardElement
                                            onChange={({ complete }) => setPaymentMethodCompleted(complete)}
                                            options={{
                                                hidePostalCode: true,
                                                style: {
                                                    invalid: {
                                                        color: Appearance.colors.red,
                                                    },
                                                    base: {
                                                        backgroundColor: Appearance.colors.textField(),
                                                        color: Appearance.colors.text(),
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        '::placeholder': {
                                                            color: Appearance.colors.subText(),
                                                        },
                                                    }
                                                }
                                            }} />
                                        </div>
                                    )
                                }}
                            </ElementsConsumer>
                        </Elements>
                    )} 
                    item={{
                        required: true,
                        title: 'Credit or Debit Card',
                        value: paymentMethodCompleted || null
                    }}
                    lastItem={true}
                    utils={utils} />
                </div>
            </div>
        )
    }

    const validateTraineeSignupLinkStatus = () => {
        let dealership = utils.dealership.get();
        setEnabled(dealership.trainee_signup.enabled);
    }

    useEffect(() => {
        validateTraineeSignupLinkStatus();
    }, []);

    return (
        <>
        <NavigationSectionHeader
        dealership={dealership} 
        eyebrow={'Careers'}
        identifier={'trainee_signup'}
        subtitle={'Start your application to train as a Safety Advisor.'}
        title={'Trainee Signup'} 
        utils={utils} />
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }}>
            {getContent()}
        </div>
        </>
    )
}

export const Troubleshooting = ({ omnishield, utils }) => {

    const [category, setCategory] = useState(null);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState('init');
    const [request, setRequest] = useState(null);

    const onAppDownloadClick = platform => {
        let omnishield = utils.dealership.omnishield.get();
        switch(platform) {
            case 'android':
            window.open(omnishield && omnishield.android.play_store_url || 'https://play.google.com/store/apps/details?id=com.commlink.omnishield2');
            break;

            case 'ios':
            window.open(omnishield && omnishield.ios.app_store_url || 'https://apps.apple.com/gb/app/omnishield/id1491369651');
            break;
        }
    }

    const onSupportClick = () => {
        window.open(data.links[browserInfo.android ? 'android' : 'ios']);
    }

    const getAppName = () => {
        if(!omnishield) {
            return '...';
        }
        if(omnishield.enabled === false) {
            return 'OmniShield App';
        }
        if(omnishield.android.app_name === omnishield.ios.app_name) {
            return `${omnishield.ios.app_name} App`;
        }
        return `${omnishield.ios.app_name} App for iOS or ${omnishield.android.app_name} App for Android`;
    }

    const getContent = () => {
        if(loading === 'init') {
            return (
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: '5vw',
                    width: '100%'
                }}>
                    <div style={{
                        ...Appearance.styles.unstyledPanel(),
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        maxWidth: 1250,
                        padding: Utils.isMobile() ? 24 : '2vw',
                        width: '100%'
                    }}>
                        <LottieView
                        autoPlay={true}
                        loop={true}
                        source={window.theme === 'dark' ? require('files/lottie/dots-white.json') : require('files/lottie/dots-grey.json')}
                        style={{
                            height: 65,
                            width: 65
                        }}/>
                    </div>
                </div>
            )
        }
        return (
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '5vw',
                width: '100%'
            }}>
                {getTroubleshootingComponents()}
            </div>
        )
    }
    
    const getOfflineCommLinkNotificationComponents = () => {
        return data !== null && (
            <>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                marginBottom: Utils.isMobile() === true ? 24 : 36,
                maxWidth: 1000,
                textAlign: 'center'
            }}>
                <img 
                src={data?.metadata.online === true ? 'images/comm-link-generic-online.png' : 'images/comm-link-generic-offline.png'}
                style={{
                    height: 150,
                    marginBottom: Utils.isMobile() === true ? 24 : 36,
                    objectFit: 'contain',
                    width: 150
                }} />
                <span style={{
                    color: Appearance.colors.text(),
                    display: 'block',
                    fontFamily: Appearance.fonts.getFamilyForWeight(800),
                    fontSize: 24
                }}>{`${data.comm_link.name} Home Safe Network`.toUpperCase()}</span>
                <span style={{
                    color: Appearance.colors.text(),
                    display: 'block',
                    fontFamily: Appearance.fonts.getFamilyForWeight(400),
                    fontSize: 18,
                    marginBottom: Utils.isMobile() === true ? 24 : 36
                }}>{data.comm_link.address?.street_address_1 ? `Located at ${data.comm_link.address?.street_address_1}` : 'Address not available'}</span>
                <span style={{
                    color: Appearance.colors.text(),
                    fontFamily: Appearance.fonts.getFamilyForWeight(400),
                    fontSize: 18,
                    marginBottom: Utils.isMobile() === true ? 24 : 36
                }}>{data.description}</span>
                <div 
                className={'row'}
                style={{
                    marginBottom: Utils.isMobile() === true ? 24 : 36
                }}>
                    <div className={'col-12 col-md-6 p-2'}>
                        <div style={{
                            ...Appearance.styles.unstyledPanel(),
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: Utils.isMobile() === true ? 24 : 36,
                            textAlign: 'center'
                        }}>
                            <span style={{
                                color: Appearance.colors.text(),
                                flexGrow: 1,
                                fontFamily: Appearance.fonts.getFamilyForWeight(400),
                                fontSize: 18,
                                marginBottom: 24
                            }}>{`For additional support, download or update the ${getAppName()} using your mobile device. The iOS app can be found on the Apple App Store and the Android app can be found on the Google Play Store.`}</span> 
                            <div style={{
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%'
                            }}>
                                <div 
                                className={'text-button'}
                                onClick={onAppDownloadClick.bind(this, 'ios')}
                                style={{
                                    backgroundColor: 'black',
                                    borderRadius: 30,
                                    height: 45,
                                    marginRight: 4,
                                    padding: 4,
                                    width: '50%'
                                }}>
                                    <img 
                                    src={'images/app-store-badge.png'}
                                    style={{
                                        height: '100%',
                                        objectFit: 'contain',
                                        width: '100%'
                                    }} />
                                </div>
                                <div 
                                className={'text-button'}
                                onClick={onAppDownloadClick.bind(this, 'android')}
                                style={{
                                    backgroundColor: 'black',
                                    borderRadius: 30,
                                    height: 45,
                                    marginLeft: 4,
                                    padding: 4,
                                    width: '50%'
                                }}>
                                    <img 
                                    src={'images/play-store-badge.png'}
                                    style={{
                                        height: '100%',
                                        objectFit: 'contain',
                                        width: '100%'
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'col-12 col-md-6 p-2'}>
                        <div style={{
                            ...Appearance.styles.unstyledPanel(),
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: Utils.isMobile() === true ? 24 : 36,
                            textAlign: 'center'
                        }}>
                            <span style={{
                                color: Appearance.colors.text(),
                                display: 'block',
                                flexGrow: 1,
                                fontFamily: Appearance.fonts.getFamilyForWeight(400),
                                fontSize: 18,
                                marginBottom: 24
                            }}>{`Once you have downloaded the ${getAppName()}, register your Comm Link using the serial number and security key on the back label. After registration, click the "Get Support" using your mobile device to open the app.`}</span> 
                            <Button 
                            color={'primary'}
                            containerStyle={{
                                width: '100%'
                            }}
                            label={'Get Support'}
                            onClick={onSupportClick}
                            style={{
                                borderRadius: 22.5,
                                height: 45,
                                maxWidth: '100%',
                                padding: '8px 18px 8px 18px'
                            }}
                            type={'large'}
                            utils={utils} />
                        </div>
                    </div>
                </div>
                <span style={{
                    color: Appearance.colors.subText(),
                    fontSize: 12
                }}>{'* We periodically check the online status of your Comm Link to help you monitor the status of your Home Safe Network but this should not be used as a fail safe indicator of your network health. You should test your Comm Link weekly to ensure that your hardware is operating correctly.'}</span>
            </div>
            </>
        )
    }
    
    const getTroubleshootingComponents = () => {
        switch(category) {
            case 'offline_comm_link_notifications':
            return (
                <div style={{
                    ...Appearance.styles.unstyledPanel(),
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    maxWidth: 1250,
                    padding: Utils.isMobile() ? 24 : '2vw',
                    width: '100%'
                }}>
                    {getOfflineCommLinkNotificationComponents()}
                </div>
            )

            case 'product_manuals':
            return (
                <ProductManuals 
                type={request.key || 'smoke'} 
                utils={utils} />
            )
        }
    }

    const fetchCommLinkOfflineNotificationData = async () => {
        try {
            setLoading('init');
            let response = await Request.get(utils, '/utils/', {
                token: request.d,
                type: 'get_offline_comm_link_notification_data'
            });

            setLoading(false);
            setData(response);

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue retrieving the details for your troubleshooting message. ${e.message || 'An unknown error occurred'}`
            });
        }
    }

    const parseRequestArguments = () => {
        switch(category) {
            case 'offline_comm_link_notifications':
            fetchCommLinkOfflineNotificationData();
            break;

            case 'product_manuals':
            setLoading(false);
            break;
        }
    }

    useEffect(() => {
        category && parseRequestArguments();
    }, [category]);

    useEffect(() => {
        let request = QueryString.parse(window.location.search);
        setRequest(request);
        setCategory(request?.category || 'product_manuals');
    }, []);
    
    return getContent();
}